import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "fresco-panel" }
const _hoisted_2 = {
  key: 0,
  class: "text-container component-container"
}
const _hoisted_3 = {
  key: 0,
  class: "start-subtitle text"
}
const _hoisted_4 = { class: "button-container component-container" }
const _hoisted_5 = ["fill"]

import { computed } from 'vue';
import { default as ColourPicker } from '@/shared/services/color';

const title = 'Need help?';

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeScreenPanelStartChat',
  props: {
  brandColour: {
    type: String,
    required: true,
  },
  actionColour: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
  },
},
  setup(__props) {

const props = __props;

const textColour = computed(() => ColourPicker.getContrastingColour(props.actionColour));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "text-container component-container" }, [
      _createElementVNode("div", { class: "start-title text header" }, _toDisplayString(title))
    ]),
    (__props.subtitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (__props.subtitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.subtitle), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        style: _normalizeStyle({
          background: __props.actionColour,
          color: textColour.value,
          'outline-color': textColour.value,
        }),
        class: "conversation-button"
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("span", null, "Chat with us", -1)),
        (_openBlock(), _createElementBlock("svg", {
          fill: textColour.value,
          class: "chat-icon",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 32 27.389"
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("path", { d: "M22.242 5H4.922C2.313 5 0 7.106 0 9.712v8.659C0 20.979 2.313 23 4.922 23h7.505l-1.137 3.619c-.099.619.527.924 1.073.691L21.605 23h.637C24.849 23 27 20.979 27 18.371V9.712C27 7.106 24.849 5 22.242 5z" }, null, -1),
          _createElementVNode("path", { d: "M27.242 0H9.922C7.92 0 6.103 1.245 5.36 3h16.882C25.969 3 29 6.011 29 9.712v7.957c1.748-.672 3-2.312 3-4.298V4.712C32 2.106 29.849 0 27.242 0z" }, null, -1)
        ]))], 8, _hoisted_5))
      ], 4)
    ])
  ]))
}
}

})